<template>
  <div class="settings-page">
    <div class="settings__nav-item">
      <router-link to="/settings/notifications">
        <p-button type="success" outline class="u-w-md"> <i class="fas fa-bell" /> {{ $t('Notifications') }} </p-button>
      </router-link>
    </div>

    <div v-if="checkScopes('listOwnUser')" class="settings__nav-item">
      <router-link :to="'/users/' + user.user_id">
        <p-button type="success" outline class="u-w-md">
          <i class="fas fa-user" /> {{ $t('myPersonalData') }}
        </p-button>
      </router-link>
    </div>

    <div v-if="checkScopes('listOwnCompany')" class="settings__nav-item">
      <router-link :to="'/companies/' + user.company.data.company_id">
        <p-button type="success" outline class="u-w-md"> <i class="fas fa-building" /> {{ $t('myCompany') }} </p-button>
      </router-link>
    </div>

    <div v-if="checkScopes('listSystemRoles')" class="settings__nav-item">
      <router-link :to="'/roles'">
        <p-button type="success" outline class="u-w-md">
          <i class="fas fa-users-cog" /> {{ $t('rightsManagement') }}
        </p-button>
      </router-link>
    </div>

    <div v-if="checkScopes('listSystemCompanies')" class="settings__nav-item">
      <router-link :to="'/super_user'">
        <p-button type="success" outline class="u-w-md">
          <i class="fas fa-user-tie" /> {{ $t('superUserPage') }}
        </p-button>
      </router-link>
    </div>

    <div class="settings__nav-item">
      <router-link :to="'/settings/applications'">
        <p-button type="success" outline class="u-w-md">
          <i class="fas fa-code"> </i> {{ $t('API Applications') }}
        </p-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import SvgUser from '../../components/svg/SvgUser';
import SvgCompany from '../../components/svg/SvgCompany';
import SvgRules from '../../components/svg/SvgRules';
import SvgSuperUser from '../../components/svg/SvgSuperUser';
import scopesChecker from '../../router/scopes/scopesChecker';

export default {
  name: 'Settings',
  components: {
    SvgUser,
    SvgCompany,
    SvgRules,
    SvgSuperUser,
  },
  data: function () {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    checkScopes: function (action) {
      return scopesChecker(null, this.$route.name, action);
    },
  },
};
</script>

<style scoped></style>
